import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { GlobalSearchService } from '../../services/global-search.service';
import { GlobalSearchRow } from '../../models/global-search';
import { DataState } from '../../modules/data/data-state.service';
import { ConnectedPosition } from "@angular/cdk/overlay";

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalSearchComponent {
  public icons = CustomIcons;
  public searchResults: GlobalSearchRow[] = [];
  public globalSearch$: Observable<GlobalSearchRow[]>;
  public searchInputControl = new UntypedFormControl();
  public searchDebouncer$ = this.searchInputControl.valueChanges.pipe(
    debounceTime(400),
    tap((val: string) => {
      this.searchResults = [];
      this.cdr.detectChanges();
      this.globalSearch$ = this.globalSearchService.getSearchForCatalogs(val).pipe(
        tap(found => {
          this.searchResults = found;
          this.isOpenSelect = true;
          this.cdr.detectChanges();
        })
      );
    })
  );
  public isOpenSelect = false;
  @Input() public overlayPosition: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top'
    }
  ];

  constructor(
    private globalSearchService: GlobalSearchService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private dataState: DataState
  ) {}

  public onChooseSearchRow($event: GlobalSearchRow): void {
    if ($event.type === 'Catalog' || $event.type === 'App') {
      this.router.navigate([$event.link], {
        queryParams: $event.queryParams
      });
    }

    if ($event.type === 'Provider') {
      const providers = this.dataState.providers.value;

      providers.forEach(p => {
        if (p.value === $event.data.idOIV) {
          p.isSelected = true;
        } else {
          p.isSelected = false;
        }
      });
      this.dataState.providers.next([...providers]);
      this.router.navigate([$event.link], $event.queryParams);
    }

    if ($event.type === 'Category') {
      const categories = this.dataState.categories.value;
      categories.forEach(c => {
        if (c.value === $event.data.idOpenCategory) {
          c.isSelected = true;
        } else {
          c.isSelected = false;
        }
      });

      this.dataState.categories.next([...categories]);
      this.router.navigate([$event.link], $event.queryParams);
    }

    if ($event.type === 'News') {
      if (window) {
        window.open($event.link, '_blank');
      }
    }

    this.isOpenSelect = false;
  }
}
